import { MyFirebase } from './my-firebase';
import { reorderArray } from 'ionic-angular';
import 'rxjs/add/operator/map';
import { Subscription } from "rxjs/Subscription";

/*
  Firebase List of Elements, can be order or not.

*/
export class MyFirebaseList {


/*

Usage

  // Build the list
  myList = constructor(elesRef : firebase.database.Reference, childrenRef : firebase.database.Reference)


  loaded() : Promise when load

  // Set the cb filter
  myList.setFilter( (ele, index, array) => {  Filter fct  });


  acces en read sur myList.elesFilterKeyValue[0].key, .value.... 
    qui evolue, ne pas modifier


  update(eleId, ele);
  push(ele) at end => eleId
  addOrUpdate(eleId, ele) : firebase.Promise<any> 
  delete(eleId)

  reorder(indexes)          // reorder filter ele with indexes.from indexes.to
  
  getPosEleId(eleId) : number     // get pos eleId ?
  getEleId(eleId) : Ele           // get the eleId


  myList.end();   // End Observe, free ressource


// Load partial, au fur et a mesure   page num, nb by page, 
// Order by index ?


  Voir
    https://github.com/angular/angularfire2/blob/master/src/database/firebase_list_factory.ts
    https://github.com/angular/angularfire2/blob/master/src/database/firebase_list_observable.ts

*/

  //
  // Constructor
  constructor(public myFirebase: MyFirebase, public elesRef : firebase.database.Reference, public childrenRef : firebase.database.Reference) {

    // this.eles = {};
    // this.children = {};
    
    this.elesRef.update( { } );
    if (this.childrenRef) this.childrenRef.update( { } );


    this.readEles();
  }


  // End of operation, free all resource
  end() {
  
    if (this.refChildrenSub) this.refChildrenSub.unsubscribe();
    if (this.refElesSub) this.refElesSub.unsubscribe();
    this.eles = null;
    this.children = null;
    this.childrenArray = null;
    this.elesKeyValue = null;
    this.elesFilterKeyValue = null;
  }

  // Promise when load
  loaded(): any {
    
    if (this.isLoaded) return Promise.resolve( true);

//@TODO Bad ...
    // Wait isLoaded
    return new Promise( (resolve)=>{
      
      let interval = setInterval( ()=> {
        if (this.isLoaded) {
          clearInterval(interval);
          resolve(true);
        }
      }, 200);
    });

  }


   
  // Current subscription
  private refElesSub : Subscription;
  private refChildrenSub : Subscription;
    
  // All ele in firebase order [id]:value
  private eles : any;

  // { [id]: position}
  private children : any;



  // Array in order of children id
  private childrenArray : Array<string>;

  // Array in order of [ { key: idEle, value: value ele } ]
  private elesKeyValue : any; // Array<{id:string, pos:number}>

  // Array filter in order of { key: idEle, value: value ele }
  public elesFilterKeyValue : any;


//@TODO comment conserver le tableau ?
// ou, subscribe change ?
// les 
  private readEles() {

    if (this.childrenRef) {

      this.refChildrenSub = this.myFirebase.getO( this.childrenRef ).subscribe( (x)=>{ 
      
        this.children = x || { };
        this.processReadChange();

      }, (e)=>{
        // Error
      }, ()=>{
        // End
      }); // this.refChildrenSub = MyFirebase.getO( this.refChildren 

    }


    this.refElesSub = this.myFirebase.getO( this.elesRef ).subscribe( (x)=>{ 

      this.eles = x || { };

      // Pas de lis de children
      if (!this.childrenRef) {
        // Add all
        this.children = { };
        for (let key in this.eles) this.children[key] = 1000000;      
      }

      this.processReadChange();

    }, (e)=>{
      // Error
    }, ()=>{
      // End
    });

  }

  private isLoaded : boolean;

  private processReadChange() {

    // Pas encore lu eles ?
    if (!this.eles) return;
    if (!this.children) return;

    this.isLoaded = true;

    // Build array of children in order
    this.childrenArray = MyFirebaseList.keySorted(this.children);

    // Reindexer this.children
    this.childrenArray.map( (value, index)=> { this.children[value] = index; });


    this.elesKeyValue = Object.keys(this.childrenArray).map( (key)=>{
      let pair = {};
      let k = 'key';
      let v = 'value'
      
      pair[k] = this.childrenArray[key];
      pair[v] = this.eles[ this.childrenArray[key] ];

// Bad ele ? null
if (pair[v] == null) {
console.log("Bad ele value null " );
}
if (pair[k] == null) {
console.log("Bad ele key null " );
}
      return pair;
    });

    // Filter
    this.setFilter(this.fctFilter);

  }





  getPosEleId(eleId) {
    return this.children[eleId];
  }


  getEleId(eleId) {
    return this.eles[eleId];
  }
  




  addOrUpdate(eleId, ele) : firebase.Promise<any> {

    // Update ?
    if(eleId) return this.update(eleId, ele);
    // Add
    return this.push( ele );    
  }


/*
TODO  
  si children, faire en simultaneé la mise a jour...
  objet avec eleId:ele et children.eleId:pos
*/

  push(ele) : firebase.Promise<any> {

    // Get Key
let eleId = this.elesRef.push().key;

    // Update internal model
this.eles[eleId] = ele;
this.children[eleId] = 100000;


// let update = { }
// update[eleId] = ele;
// if (this.childrenRef) { update['orders'] = { };  update['orders'][eleId] = 100000; }
// return this.elesRef.update( update );

    // Update Firebase
    if (this.childrenRef) {
      return Promise.all( [  
        this.elesRef.child(eleId).set( ele ), 
        this.childrenRef.child(eleId).set(100000) ]);
    } 
    
    return this.elesRef.child(eleId).set( ele );

    // return this.elesRef.child(eleId).set( ele ).then( (x) => { 
    //   if (this.childrenRef) {
    //     return this.childrenRef.child(eleId).set(100000);
    //   }
    //   return x;
    // });
  }


  update(eleId, ele)  : firebase.Promise<any> {
  
// let update = { }
// update[eleId] = ele;
// if ( (this.childrenRef) && ( (this.children==null) || (this.children[eleId]==null) ) )  
//   { update['orders'] = { };  update['orders'][eleId] = 100000; }
// return this.elesRef.update( update );

    // Update internal model
this.eles[eleId] = ele;
if ((this.children==null) || (this.children[eleId]==null)) this.children[eleId] = 100000;

    // Update Firebase
    if (this.childrenRef) {

      return Promise.all( [  
        this.elesRef.child(eleId).set( ele ), 
        this.childrenRef.child(eleId).set( this.children[eleId] ) ]);
      
      // return this.elesRef.child(eleId).update( ele ).then( ()=>{ 
      //   return this.childrenRef.child(eleId).update(100000);
      // });
    }

    return this.elesRef.child(eleId).update( ele );    
  }

 
  delete(eleId)  : firebase.Promise<any> {   
    
// let update = { }
// update[eleId] = null;
// if (this.childrenRef) { update['orders'] = { };  update['orders'][eleId] = null; }
// return this.elesRef.update( update );
    
    // Update internal model
    delete this.elesRef[eleId];
    delete this.children[eleId];

    // Update Firebase
    if (this.childrenRef) {  
      this.elesRef.child ( eleId ).remove();
      return this.childrenRef.child(eleId).remove();
    }

    return this.elesRef.child ( eleId ).remove();
  }


  reorder(indexes){

    // Si filter
console.log('eorder from ' + indexes.from + ' to ' + indexes.to  );
    indexes.from = this.children[this.elesFilterKeyValue[indexes.from].key];
    indexes.to = this.children[this.elesFilterKeyValue[indexes.to].key];
console.log('eorder from ' + indexes.from + ' to ' + indexes.to  );
    MyFirebaseList.reorderKey(this.children, indexes);

// let update = { }
// update['orders'] = this.children;
// return this.elesRef.update( update );

    this.childrenRef.set(this.children);
  }



  // Fct filter
  private fctFilter : any;

  // Set the cb filter (ele, index, array) => { }
  setFilter(fctFilter) {

    this.fctFilter = fctFilter;

    this.elesFilterKeyValue = (this.fctFilter) 
      ? this.elesKeyValue.filter( (ele, index, array)=>{ return this.fctFilter(ele, index, array); }) 
      : this.elesKeyValue;
  }

/*

  Promise de premiere lecture ?
  Promise d'etre a jour ?



*/






  // Return an array of key of obj, sort by value, key
  static keySorted(obj:any): Array<string> {

    return Object.keys(obj).sort( (a,b) => {

      let v = obj[a]-obj[b];
      if (v!=0) return v;
      return a.localeCompare(b);
    });

  }

  // Reorder key of obj
  static reorderKey(obj:any, indexes):any {

    // reorder key of itemParent.data.children
    let keys = this.keySorted(obj);
    reorderArray(keys, indexes);
    for( let i=0; i<keys.length; i++) {
      obj[keys[i]] = i;
    }
    return obj;
  }



}

/*
  TODO Amelioration

    push, update, delete
      ne faire q'une operation d'update sur Fiurebase pour que list soit syncronisé
    idem order

    si modif, et que observable ne fait pas lecture, ? 
      tenir a jor les variables interne ?
    

*/



/*
  Gestion order
      un id specifique 'orders' 
      avec index et id ou id et index


    TODO Big size of data, how to ? paginated




 // Get list item
  getItemListO(level : string) : Observable< Array<Observable<IItem>>> {

    // item level
    return Items.getO(level).map( ( itemLevel, idx )=> { 

      if (!itemLevel.data.children) return null;
        
      // Sort according value...
      let children = this.keySorted(itemLevel.data.children);
  
      let arr = new Array<Observable<IItem>> ();
      for (let i = 0; i< children.length; i++) {

        arr[i] = Items.getO(children[i]);
      }

      return arr;
    } );

  }
*/



// WEBPACK FOOTER //
// ./src/providers/my-firebase-list.ts